goog.provide("shadow.js.shim.module$$mui$material$CircularProgress");
goog.provide("module$shadow_js_shim_module$$mui$material$CircularProgress");
shadow.js.shim.module$$mui$material$CircularProgress = shadow.js.nativeProvides["@mui/material/CircularProgress"] = shadow$bridge("@mui/material/CircularProgress");
module$shadow_js_shim_module$$mui$material$CircularProgress.default = shadow.js.shim.module$$mui$material$CircularProgress;
